import Phaser from "phaser";
import { GAME_WIDTH } from "../constants";
import { addCoverImage, addPanel } from "../ui/chrome";
import { MenuButton, bindMenuKeys } from "../ui/MenuButton";
import { bodyStyle, titleStyle } from "../ui/theme";
import { audioManager } from "../systems/AudioManager";
import { assetOrigin } from "../assets/loader";

interface GameOverData {
  score: number;
}

export class GameOverScene extends Phaser.Scene {
  private score = 0;

  constructor() {
    super("GameOver");
  }

  init(data: GameOverData): void {
    this.score = data.score ?? 0;
  }

  create(): void {
    audioManager.playMusic("menu");
    addCoverImage(this, "menu-background");
    addPanel(this, GAME_WIDTH / 2, 360, 520, 420);

    const bear = this.add.sprite(GAME_WIDTH / 2, 228, "bear-game-over", 0);
    const origin = assetOrigin("bear-game-over");
    bear.setOrigin(origin.x, origin.y).setScale(0.42).play("bear-game-over");

    this.add
      .text(GAME_WIDTH / 2, 318, "Game Over", titleStyle(36))
      .setOrigin(0.5)
      .setColor("#2a1a10")
      .setStroke("#000000", 0);
    this.add
      .text(
        GAME_WIDTH / 2,
        368,
        `Score  ${this.score}\nThis run did not reach the cave.`,
        bodyStyle(18),
      )
      .setOrigin(0.5)
      .setWordWrapWidth(420);

    const retry = new MenuButton(this, GAME_WIDTH / 2 - 118, 448, "Try Again", () => this.scene.start("Game"), 200);
    const menu = new MenuButton(this, GAME_WIDTH / 2 + 118, 448, "Menu", () => this.scene.start("Menu"), 200, "secondary");
    bindMenuKeys(this, [retry, menu]);
  }
}
